<template>
  <div class="g-inherit m-article">
    <div class="mainContent">
      <div class="chatContent" :class="{superMan:sessionId == superMan}">
        <!--阅片-->
        <el-card class="box-card" style="height:100%" v-if="!isHistory">
          <!--聊天-->
          <div>
            <div slot="header" class="clearfix">
              <div class="headerWarpper">
                <span>
                  <el-page-header @back="goBack" :content="sickInfo.name || lastPageName"></el-page-header>
                </span>
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="getHistory(true)"
                  v-if="sessionId!=superMan"
                >云记录</el-button>
              </div>
            </div>
            <div class="c_bd">
              <ChatList
                type="session"
                :msglist="msglist"
                :userInfos="userInfos"
                :myInfo="myInfo"
                :isRobot="isRobot"
                :caseId="sickInfo.id"
                @msgs-loaded="msgsLoaded"
                @on-list-avatar="onListAvatar"
                ref="chatList"
              />
            </div>
            <div class="c_ft">
              <ChatEditor
                v-show="sessionId != superMan"
                :scene="scene"
                :to="to"
                :isRobot="isRobot"
                :orderId="sickInfo.orders_id"
                type="session"
                :invalid="teamInvalid || muteInTeam"
                :invalidHint="sendInvalidHint"
                :advancedTeam="teamInfo && teamInfo.type === 'advanced'"
              />
            </div>
          </div>
        </el-card>
        <!--历史记录-->
        <el-card class="box-card history" style="height:100%" v-if="isHistory">
          <div slot="header" class="clearfix">
            <div class="headerWarpper">
              <span>
                <el-page-header @back="getHistory(false)" content="历史记录"></el-page-header>
              </span>
            </div>
          </div>
          <div>
            <chat-list
              ref="chatlist"
              type="session"
              :canLoadMore="canLoadMore"
              :msglist="msglist"
              :userInfos="userInfos"
              :myInfo="myInfo"
              :isHistory="true"
            ></chat-list>
          </div>
        </el-card>
      </div>
      <!--患者资料-->
      <div class="patientsContent" v-show="sessionId != superMan">
        <div class="topBox">
          <el-card class="box-card" style="height:100%;">
            <div slot="header" class="clearfix">
              <span class="title">病历资料</span>
              <el-button
                style="float: right; padding: 0;"
                type="text"
                @click="detailHandle(sickInfo)"
              >查看详情</el-button>
            </div>
            <div class="p_bd">
              <div>
                <span class="title">姓名:</span>
                <span class="txt">{{sickInfo.name}}</span>
              </div>
              <div>
                <span class="title">性别:</span>
                <span class="txt">{{sickInfo.gender_text}}</span>
              </div>
              <div>
                <span class="title">出生日期:</span>
                <span class="txt">{{sickInfo.birthdate}}</span>
              </div>
              <!-- <div>
                <span class="title">所属科室:</span>
                <span class="txt">{{sickInfo.department_name}}</span>
              </div>-->
            </div>
          </el-card>
        </div>
        <div class="botBox">
          <el-card class="box-card diagnosis">
            <span class="prescription" @click="prescription">处方列表</span>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="诊断结果" name="first">
                <div class="p_bd">
                  <el-form ref="caseForm" label-width="120px" :model="caseForm" :rules="caseRules">
                    <!-- 成功 -->
                    <el-alert
                      v-if="sickInfo.prescription_status===2 "
                      v-html="sickInfo.prescription_status_describe"
                      center
                      effect="dark"
                      :closable="false"
                      type="success"
                    ></el-alert>
                    <!-- 待开 -->
                    <el-alert
                      v-else-if="sickInfo.prescription_status===-100 "
                      v-html="sickInfo.prescription_status_describe"
                      center
                      effect="dark"
                      :closable="false"
                      type="info"
                    ></el-alert>
                    <!-- 0 1 待审核 -->
                    <el-alert
                      v-else-if="sickInfo.prescription_status===1 || sickInfo.prescription_status===0"
                      v-html="sickInfo.prescription_status_describe"
                      center
                      effect="dark"
                      :closable="false"
                      type="warning"
                    ></el-alert>
                    <!-- -1 -2 拒绝 -->
                    <el-alert
                      v-else-if="sickInfo.prescription_status===-1 || sickInfo.prescription_status===-2 "
                      v-html="sickInfo.prescription_status_describe"
                      center
                      effect="dark"
                      :closable="false"
                      type="error"
                    ></el-alert>
                    <div style="margin-bottom: 20px;">
                      <div class="logo-ps"></div>
                      <el-button
                        type="text"
                        style="float:right;margin-left:20px;"
                        size="small"
                        @click="prescriptionSelect"
                      >+添加药品</el-button>
                    </div>

                    <el-form-item label="诊断结果" prop="diagnose_result">
                      <!-- <el-autocomplete
                        style="width:100%"
                        popper-class="my-autocomplete"
                        v-model="diagnose_result"
                        placeholder="请输入内容"
                         :fetch-suggestions="querySearch"
                        @focus='diagnoseResult=true'
                      >
                       
                        <template slot-scope="{ item }">
                          <div class="name">{{ item.content }}</div>
                        </template>
                      </el-autocomplete>-->
                      <el-input
                        v-model="diagnose_result"
                        @focus="diagnoseResult=true"
                        placeholder="请选择内容"
                      ></el-input>
                    </el-form-item>

                    <!-- 选择中药品展示栏 -->
                    <div v-if="selectDrugList && selectDrugList.length !=0" class="drugList">
                      <div class="drug_title">所选药品:</div>
                      <div class="drug-item">
                        <el-collapse v-if="selectDrugList" class="drug-list">
                          <el-collapse-item
                            class="_item"
                            :title="item.title"
                            :name="index"
                            v-for="(item,index) in selectDrugList"
                            :key="index"
                          >
                            <div class="desc">
                              <p>药品规格:{{item.specs}}</p>
                              <p>数量:{{item.quantity}}</p>
                              <p>单次用量:{{item.dosage}}/{{item.unit}}</p>
                              <p>给药频率:{{item.frequency}}</p>
                              <p>给药途径:{{item.from}}</p>
                              <p>用药天数:{{item.time}}</p>
                              <p>补充说明:{{item.remark}}</p>
                            </div>
                            <div class="drug-edit">
                              <el-button type="primary" round @click="editDrug(index)">编辑</el-button>
                            </div>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                    </div>

                    <!-- ------ -->
                    <el-button
                      style="width:100%"
                      type="primary"
                      v-bind:disabled="sickInfo.prescription_status===2  || sickInfo.prescription_status===0 || sickInfo.prescription_status===1 "
                      :class="{disColor:sickInfo.prescription_status===2  || sickInfo.prescription_status===0 || sickInfo.prescription_status===1}"
                      @click="addDrugForm()"
                    >提交</el-button>
                    <!-- @click="setPrescription()" -->

                    <!-- </el-form-item> -->
                  </el-form>
                </div>
              </el-tab-pane>
              <el-tab-pane label="结束诊断" name="second">
                <el-button
                  v-bind:disabled="sickInfo.prescription_status===2 "
                  :class="{disColor:sickInfo.prescription_status===2  }"
                  class="end_chat"
                  style="width:100%"
                  type="primary"
                  @click="endChat()"
                >结束诊断</el-button>
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </div>
      </div>
    </div>
    <!-- 弹窗 this.drugShow = true; -->
    <el-dialog :visible.sync="drugShow" width="80%" center>
      <drug-panel @on-drug-add="onDrugAdd" @on-delete="onDelete" :drugs="drugs" ref="drugPanel" />
    </el-dialog>
    <!-- 弹窗 this.drugShow = true; -->
    <el-dialog :visible.sync="diagnoseResult" width="50%" center>
      <disease-code @on_disease_code="on_disease_code" />
    </el-dialog>
  </div>
</template>

<script>
import ChatEditor from "@/components/chart/ChatEditor";
import ChatList from "@/components/chart/ChatList";
import drugPanel from "@/components/drugPanel";
import diseaseCode from "@/components/diseaseCode";
import util from "@/utils";
import pageUtil from "@/utils/page";

import {
  getDoctorInfo,
  prescriptionAdd,
  setCaseReport,
  drugSearch,
  patientsInfo,
  setPatientReport,
  setPrecriptionReport,
  readfilmList,
  diagnose_result_search,
  getSystem,
  ordersClose
} from "@/api";
export default {
  components: {
    ChatEditor,
    ChatList,
    drugPanel,
    diseaseCode
  },
  beforeUpdated() {
    // 提交sdk连接请求
    this.$store.dispatch("connect");
    this.$store.dispatch("updateRefreshState");
  },
  updated() {
    // 提交sdk连接请求
    this.$store.dispatch("connect");
    this.$store.dispatch("updateRefreshState");
  },
  // 进入该页面，文档被挂载
  mounted() {
    this.initPatientsInfo();
    this.initDurgSearch();
    this.system_list();
    // 此时设置当前会话
    this.$store.dispatch("setCurrSession", this.sessionId);
    setTimeout(() => {
      this.getHistoryMsgs();
    }, 2000);
    this.tipsMessage();
  },
  // 离开该页面，此时重置当前会话
  destroyed() {
    if (window.nim) {
      this.$store.dispatch("resetCurrSession");
    }
  },
  data() {
    return {
      superMan: "p2p-21232f297a57a5a743894a0e4a801fc3",
      restaurants: [],
      timeout: null,
      isHistory: false,
      elSelect: false,
      chatType: "",
      lastPageName: "聊天",
      uploadUrl: process.env.VUE_APP_BASE_API + "pc/publics/upload",
      leftBtnOptions: {
        backText: " ",
        preventGoBack: true
      },
      caseForm: {
        drugs_id: "",
        quantity: "",
        dosage: "",
        unit: "",
        frequency: "",
        from: "",
        time: "",
        remark: "",
        specs: ""
      },
      prescription_type: "",
      diagnose_result: "",
      disease_code: "",
      options: [], //药品
      value: "",
      caseRules: {
        quantity: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur"
          }
        ],
        dosage: [
          {
            required: true,
            message: "请输入用量",
            trigger: "blur"
          }
        ],
        unit: [
          {
            required: true,
            message: "请输入单位",
            trigger: "blur"
          }
        ],
        frequency: [
          {
            required: true,
            message: "请输入给药频率",
            trigger: "blur"
          }
        ],
        from: [
          {
            required: true,
            message: "请输入药品途径",
            trigger: "blur"
          }
        ],
        time: [
          {
            required: true,
            message: "请输入用药天数",
            trigger: "blur"
          }
        ]
      },
      sickInfo: {},
      fileList: [],
      editableTabsValue: "0",
      editableTabs: [], //药品标题数组
      tabIndex: -1,
      select: "",
      drugs: [],
      tabTitleIndex: "",
      drugs_system_list: "",
      activeName: "first",
      pageNum: 0,
      drugShow: false,
      selectDrugList: [],
      curDrugItem: "",
      diagnoseResult: false
    };
  },
  computed: {
    sessionId() {
      let sessionId = this.$route.query.sessionId;
      console.log("sessionId:", sessionId);
      return sessionId;
    },
    sessionName() {
      let sessionId = this.sessionId;
      let user = null;
      if (/^p2p-/.test(sessionId)) {
        user = sessionId.replace(/^p2p-/, "");
        if (user === this.$store.state.userUID) {
          return "我的手机";
        } else if (this.isRobot) {
          return this.robotInfos[user].nick;
        } else {
          let userInfo = this.userInfos[user] || {};
          return util.getFriendAlias(userInfo);
        }
      }
    },
    scene() {
      return util.parseSession(this.sessionId).scene;
    },
    to() {
      return util.parseSession(this.sessionId).to;
    },
    // 判断是否是机器人
    isRobot() {
      let sessionId = this.sessionId;
      let user = null;
      if (/^p2p-/.test(sessionId)) {
        user = sessionId.replace(/^p2p-/, "");
        if (this.robotInfos[user]) {
          return true;
        }
      }
      return false;
    },
    myInfo() {
      return this.$store.state.myInfo;
    },
    userInfos() {
      return this.$store.state.userInfos;
    },
    robotInfos() {
      return this.$store.state.robotInfos;
    },
    msglist() {
      let msgs = this.$store.state.currSessionMsgs;
      console.log("msgs:", msgs);
      return msgs;
    },
    teamInfo() {
      if (this.scene === "team") {
        var teamId = this.sessionId.replace("team-", "");
        return this.$store.state.teamlist.find(team => {
          return team.teamId === teamId;
        });
      }
      return undefined;
    },
    muteInTeam() {
      if (this.scene !== "team") return false;
      var teamMembers = this.$store.state.teamMembers;
      var Members = teamMembers && teamMembers[this.teamInfo.teamId];
      var selfInTeam =
        Members &&
        Members.find(item => {
          return item.account === this.$store.state.userUID;
        });
      return (selfInTeam && selfInTeam.mute) || false;
    },
    teamInvalid() {
      if (this.scene === "team") {
        return !(this.teamInfo && this.teamInfo.validToCurrentUser);
      }
      return false;
    },
    sendInvalidHint() {
      if (this.scene === "team" && this.teamInvalid) {
        return `您已不在该${
          this.teamInfo && this.teamInfo.type === "normal" ? "讨论组" : "群"
        }，不能发送消息`;
      } else if (this.muteInTeam) {
        return "您已被禁言";
      }
      return "无权限发送消息";
    },
    canLoadMore() {
      return !this.$store.state.noMoreHistoryMsgs;
    }
  },
  methods: {
    /**
     * 诊断结果
     */
    on_disease_code(data, type) {
      console.log(data, type);
      this.diagnoseResult = type;
      this.diagnose_result = data.title;
      this.disease_code = data.code;
    },
    //结束诊断
    endChat() {
      const params = {
        orders_id: this.sickInfo.orders_id
      };
      ordersClose(params).then(res => {
        if (res.code === 1) {
          this.$message({
            type: "success",
            message: "本次诊断结束"
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
        this.initPatientsInfo();
      });
    },
    handleClick(tab, event) {},
    changeType(keyword) {
      if (keyword == 1 || keyword == 2) {
        this.pageNum = 0; //切换药品类型时，重置为0，下面+1 = 1 访问成1
      }
      this.pageNum = this.pageNum + 1;
      this.options = [];
      let data = {
        type: this.prescription_type,
        keyword: this.value,
        cate_id: "1",
        pageNum: this.pageNum,
        pageSize: "10"
      };
      drugSearch(data).then(res => {
        this.options = this.options.concat(res.data.data);
      });
    },
    tipsMessage() {
      if (this.sessionId == this.superMan) {
        return;
      }
      //读取sessionStorage 提示只提示一次
      const tipsMessage = JSON.parse(sessionStorage.getItem("tipsMessage"));
      if (tipsMessage == 1) {
        return;
      }
      //将信息存入本地缓存sessionStorage
      sessionStorage.setItem("tipsMessage", JSON.stringify(1));
      this.$notify({
        title: "温馨提示",
        dangerouslyUseHTMLString: true,
        message: `<div>1、医生须完整查看患者病例后开始诊疗行为。</div>
          <div>2、根据相关规定，互联网医院不得为低龄儿童（6岁以下）开具互联网儿童用药处方。</div>
          <div>3、根据相关规定，互联网医院不得开具麻醉药品、精神药品等特殊管理药品的处方。</div>`,
        type: "warning",
        duration: 8000
      });
    },
    /*
      切换药品事件
      通过两个数组对应索引的位置赋值
    */
    tabClick(item) {
      this.tabTitleIndex = item.index;
      for (let i = 0; i < this.drugs.length; i++) {
        if (item.index == i) {
          this.caseForm = this.drugs[i];
        }
      }
    },

  isTipPreOrder(){
      const that = this;
      this.$confirm('您的处方已被拒绝，需要您再次查看病历信息，处方信息以后继续操作?', '提示', {
        confirmButtonText: '前去查看',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
         sessionStorage.setItem("tipPreOrder"+that.sickInfo.orders_id, JSON.stringify(1));
        that.detailHandle(that.sickInfo);
      }).catch(() => {
        // 取消  啥也不干 不能再提交处方
      });
  },

    /**
     * 添加药品按钮
     *
     * 条件1.tipPreOrder存在（查看处方）2.tipPreOrder值为！1  3.订单id相同 4.必须是拒绝状态 -1 -2 
     **/
    prescriptionSelect() {
      const that =this;
      // sessionStorage.removeItem('tipPreOrder'+that.sickInfo.orders_id);
      const tipPreOrder = JSON.parse(sessionStorage.getItem("tipPreOrder"+that.sickInfo.orders_id));
      console.log(tipPreOrder,'tipPreOrder');
      if(this.sickInfo.prescription_status ==-1 || this.sickInfo.prescription_status==-2 ){
        if(tipPreOrder ==null){
          this.isTipPreOrder()
        }else{
          this.drugShow = true;
          this.$nextTick(() => {
            this.$refs.drugPanel.initRight();
          });
        }
      }else{
        this.drugShow = true;
        this.$nextTick(() => {
          this.$refs.drugPanel.initRight();
        });
      }

    },
    /**
     * 输入监听事件
     */
    input(value) {
      this.$forceUpdate();
      let tabIndex = this.tabTitleIndex || this.tabIndex; //当前数组索引
      let drugs = this.drugs;
      for (let i = 0; i < this.drugs.length; i++) {
        if (tabIndex == i) {
          if (value === "quantity") {
            drugs[tabIndex].quantity = this.caseForm.quantity;
          } else if (value === "dosage") {
            drugs[tabIndex].dosage = this.caseForm.dosage;
          } else if (value === "unit") {
            drugs[tabIndex].unit = this.caseForm.unit;
          } else if (value === "frequency") {
            drugs[tabIndex].frequency = this.caseForm.frequency;
          } else if (value === "from") {
            drugs[tabIndex].from = this.caseForm.from;
          } else if (value === "time") {
            drugs[tabIndex].time = this.caseForm.time;
          } else if (value === "remark") {
            drugs[tabIndex].remark = this.caseForm.remark;
          }
        }
      }
    },
    loadMore() {},
    /**
     * 添加药方
     */
    addTab(targetName) {

      let selectedWorkName = {};
      selectedWorkName = this.options.find(item => {
        return item.id === this.value;
      });
      let newTabName = ++this.tabIndex + "";
      this.editableTabs.push({
        title: selectedWorkName.content,
        name: newTabName,
        specs: selectedWorkName.specs,
        drugs_id: selectedWorkName.id
      });
      /**
       * 如果过这里要增加或者减少字段，修改提交中的长度判断
       * //药品id
       * //名称
       * //药品规格
       * name用于模仿官方删除
       */
      let new_drugs = {
        drugs_id: selectedWorkName.id,
        drugs_name: selectedWorkName.content,
        specs: selectedWorkName.specs,
        name: newTabName
      };
      this.drugs.push(new_drugs);
      this.elSelect = false;
      console.log("this.drugs", this.drugs);
    },
    /**
     * 删除药品
     */
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      let drugs = this.drugs;
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      this.drugs = drugs.filter(tab => tab.name !== targetName);
      console.log("this.drugs", this.drugs);
    },

    detailHandle(sickInfo) {
      console.log('detailHandle->sickInfo:',sickInfo);
      let query = {
        case_id: sickInfo.id,
        sessionId: this.$route.query.sessionId,
        prescription_id: sickInfo.prescription_id
      };
      this.$router.push({
        path: "/index/work/patientDetails",
        query
      });
    },
    /*
      处方列表跳转
    */
    prescription() {
      this.$router.push({
        path: "/index/user/prescription"
      });
    },
    //切换历史记录
    getHistory(type) {
      //true 云记录 false 返回
      this.isHistory = type;
      type == true
        ? (this.lastPageName = "历史记录")
        : (this.lastPageName = "聊天");
    },
    //获取下拉选项
    system_list() {
      let data = {
        type: "all"
      };
      getSystem(data).then(res => {
        this.drugs_system_list = res.data;
      });
    },

    //这里获取诊断的搜索
    initDurgSearch() {
      diagnose_result_search({}).then(res => {
        this.restaurants = res.data;
      });
    },
    // querySearch(queryString, cb) {
    //   var restaurants = this.restaurants;
    //   var results = queryString
    //     ? restaurants.filter(this.createFilter(queryString))
    //     : restaurants;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.content
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    // //生成报告 TODO:
    // initCaseReport(command) {
    //   if (command == "case") {
    //     this.setCaseReport();
    //   } else if (command == "prescription") {
    //     this.setPrescription();
    //   }
    // },
    // //生成病例报告
    // setCaseReport() {
    //   let data = {
    //     orders_id: this.sickInfo.orders_id
    //   };
    //   setCaseReport(data).then(res => {
    //     console.log("生成病例报告", res);
    //     if (res.code == 1) {
    //       this.$message({
    //         type: "success",
    //         message: "报告生成成功"
    //       });
    //     } else {
    //       this.$message({
    //         type: "error",
    //         message: "报告生成失败"
    //       });
    //     }
    //   });
    // },
    //上传成功
    handleDataSuccess(res, file) {
      const that = this;
      this.caseForm.images.push(res.data.url);
    },
    //上传之前
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("图片格式错误");
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //药方添加
    setPrescription() {
      // 1.判断数组字段内容是否为空
      // 2.判断数组字段长度是否为12
      for (var i = 0; i < this.drugs.length; i++) {
        var new_drugs = this.drugs[i];
        const title = "";
        for (let k in new_drugs) {
          if (k == "drugs_name") {
            title = new_drugs[k];
          }
          if (
            new_drugs[k] == "" ||
            new_drugs[k] == undefined ||
            new_drugs[k] == null
          ) {
            this.$message.error(title + "药品有内容未填写");
            return;
          }
        }
        if (Object.keys(new_drugs).length < 10) {
          this.$message.error(title + "药品有内容未填写");
          return;
        }
      }
      this.$refs.caseForm.validate(valid => {
        if (valid) {
          const params = {
            type: this.prescription_type,
            orders_id: this.sickInfo.orders_id,
            drugs: this.drugs,
            diagnose_result: this.diagnose_result
          };
          prescriptionAdd(params).then(res => {
            if (res.code === 1) {
              this.$message({
                type: "success",
                message: res.msg
              });
              this.initPatientsInfo();
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          this.$message({
            type: "error",
            message: "请完成内容"
          });
          return false;
        }
      });
    },
    //药方添加new
    addDrugForm() {
      var that = this;

      if (this.selectDrugList == "") {
        this.$message({
          type: "error",
          message: "请添加处方"
        });
        return;
      }
      if (this.diagnose_result == "") {
        this.$message({
          type: "error",
          message: "请选择诊断结果"
        });
        return;
      }

      const params = {
        type: this.selectDrugList[this.selectDrugList.length - 1].durgType, //多药品提交药方，药方类别不能和药品类别统一 :是个bug
        orders_id: this.sickInfo.orders_id,
        drugs: this.selectDrugList,
        diagnose_result: this.diagnose_result,
        disease_code: this.disease_code
      };
      prescriptionAdd(params).then(res => {
        if (res.code === 1) {
          this.$message({
            type: "success",
            message: res.msg
          });
          sessionStorage.removeItem('tipPreOrder'+that.sickInfo.orders_id);
          this.initPatientsInfo();
          this.sendAddDrugMsg();
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    //发送处方提交消息
    sendAddDrugMsg() {
      this.$store.dispatch("sendTipMsg", {
        scene: this.scene,
        to: this.to,
        tip: "药师正在审核处方，请您耐心等待！"
      });
    },
    //初始化患者信息
    initPatientsInfo() {
      var sick_im_accid = getCaption(this.$route.query.sessionId);
      let data = {
        sick_im_accid: sick_im_accid
      };
      patientsInfo(data).then(res => {
        if (res.code === 1) {
          this.sickInfo = res.data ? res.data : "";
          this.caseForm.orders_id = this.sickInfo.orders_id;
        } else {
          this.$message({
            showClose: true,
            message: result.msg,
            type: "error"
          });
        }
      });

      function getCaption(obj) {
        var index = obj.lastIndexOf("-");
        obj = obj.substring(index + 1, obj.length);
        return obj;
      }
    },
    getHistoryMsgs() {
      this.$store.dispatch("getHistoryMsgs", {
        scene: this.scene,
        to: this.to
      });
    },
    goBack() {
      let fromType = this.$route.query.fromType;
      if (fromType == "workdetail") {
        this.$router.push({
          path: "/index/user/patients",
        });
      } else {
        this.$router.push({
          path: "/index/work/appointment"
        });
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    /**
     * 删除图片方法
     */
    handleRemove(file, fileList) {
      const url = file.response.data.url;
      for (var i = 0; i < this.caseForm.images.length; i++) {
        if (this.caseForm.images[i] == url) {
          this.caseForm.images.splice(i, 1);
        }
      }
      console.log("caseForm.images", this.caseForm.images);
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    onClickBack() {
      window.stopPlayAudio && window.stopPlayAudio();
      window.history.go(-1);
    },
    msgsLoaded() {},
    //头像点击
    onListAvatar(item) {
      let sickInfo = this.sickInfo;
      if (sickInfo.is_hava_report == 1) {
        this.$router.push({
          path: "/index/user/reportManage"
        });
        return;
      }
      if (
        sickInfo.im_accid &&
        sickInfo.sick_id &&
        sickInfo.id &&
        sickInfo.orders_id
      ) {
        let query = {
          sickImId: sickInfo.im_accid,
          sickId: sickInfo.sick_id,
          casesId: sickInfo.id,
          orderId: sickInfo.orders_id,
          from: "chat"
        };
        this.$router.push({
          path: "/index/work/slice",
          query
        });
      } else {
        this.$message({
          type: "warning",
          message: "患者信息不完善，请提醒患者完善信息"
        });
      }
    },

    //药品添加
    onDrugAdd(items) {
      this.drugShow = false;
      let curIndex = "";
      console.log("items:", items);
      if (this.selectDrugList.length == 0) {
        this.selectDrugList.push(items);
      } else {
        let same = this.selectDrugList.filter((cur, index, arr) => {
          if (items.id == cur.id) {
            curIndex = index;
          }
          return items.id == cur.id;
        });
        console.log("same:", same);
        if (same && same.length != 0) {
          this.selectDrugList[curIndex] = items;
        } else {
          this.selectDrugList.push(items);
        }
      }
    },
    //删除
    onDelete(item) {
      let curIndex;
      this.selectDrugList.filter((cur, index, arr) => {
        if (item.id == cur.id) {
          curIndex = index;
        }
      });
      this.selectDrugList.splice(curIndex, 1);
      this.$message({
        type: "success",
        message: "删除成功"
      });
      this.$refs.drugPanel.rest();
      this.drugShow = false;
    },
    //编辑事件-药品
    editDrug(index) {
      this.drugShow = true;
      let item = this.selectDrugList[index];
      this.$nextTick(() => {
        this.$refs.drugPanel.initDetail(item);
      });
    }
  }
};
</script>
<style lang="scss" >
.g-inherit {
  padding: 0 20px;
  .mainContent {
    display: flex;
    flex-direction: row;
    flex: 1;
    margin: 15px 0;
    .chatContent {
      flex: 0 0 66%;
      margin: 0 20px 5px 20px;

      .c_ft {
        border-top: 1px solid #ccc;
        padding-top: 32px;
        position: relative;
      }
    }
    .patientsContent {
      flex: 0 0 30%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .topBox {
        // height: 30%;
        .p_bd {
          line-height: 40px;
          color: #606266;
          width: 100%;
          overflow: hidden;
          .txt {
            float: right;
          }
        }
      }
      .botBox {
        margin-top: 20px;
        margin-bottom: 5px;
        flex: 1;
        .prescription {
          // color: #409eff;
          color: #FC701A;
          padding: 12px 10px;
          float: right;
          cursor: pointer;
        }
        .el-tabs__header {
          width: 80% !important;
        }
        .diagnosis {
          height: 100%;
        }
      }
    }
  }
}
.clearfix {
  .title {
    padding-left: 15px;
    // border-left: 3px solid rgb(0, 175, 255);
    border-left: 3px solid #FC9710;
  }
}

.pageWarpper {
  width: 100%;

  text-align: center;
}
.patientsContent .el-alert {
  margin-bottom: 20px;
}
.logo-ps {
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background-color: #fc9710;
  &::before {
    position: absolute;
    content: "";
    display: inline-block;
    width: 30px;
    height: 20px;
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::after {
    position: absolute;
    content: "RP";
    font-size: 16px;
    display: inline-block;
    color: #fff;
  }

  .prescrBtn {
    // float:right!important;
    float: right !important;
    font-weight: 700 !important;
    margin-left: 20px;
  }
}
.superMan {
  flex: 0 0 96% !important;
}
.more {
  // border-top:1px solid rgba(0,0,0,0.6);
  padding: 5px 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  text-align: center;
}
.drugList {
  margin: 20px 0;
  .drug_title {
    font-size: 16px;
    color: #FC701A;
    margin: 10px 0;
  }
  .drug-item {
    .drug-edit {
      text-align: right;
      button {
        padding: 6px 19px !important;
      }
    }
  }
}
</style>
